<div class="ion-content">
  <div slot="start" class="logo-container">
      <span (click)="redirectToLogin()" class="flex-row">
        <span class="logo"></span>
        <span class="logo-text">
          <p class="h1">Promo</p>
          <p class="h1">Portal</p>
        </span>
      </span>
  </div>

  <div *ngIf="verApproved"
       class="auth-content" [ngClass]="{'desktop': !isDevicePlatform}">
    <div class="label">
      Your Promo Portal account is now verified!
    </div>

    <div class="auth-template">
      <ion-button type="button"
                  color="success"
                  expand="full"
                  shape="round"
                  class="auth-button fadeInRight delay-0s7"
                  (click)="redirectToLogin()">
        Click Here to Login
      </ion-button>
    </div>
  </div>

  <div *ngIf="verForApproval"
       class="auth-content">
    <div class="label">
      Your Promo Portal account is sent for verification.
    </div>
  </div>

  <div class="sony-music-logo fadeIn delay-1s"></div>
</div>
